'use strict';

import React from 'react';
import Collapsible from 'react-collapsible';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Logger from '../../../utils/Logger';

const { id: module_id } = module;
const logger = Logger(module_id);

// this is just a placeholder
const Trigger = ({ icon, name }) => {
  return (
    <span>
      <i className={icon} /> <h2 style={{ marginLeft: '5px' }}>{name}</h2>
    </span>
  );
};

export { Trigger };

class CollapsibleContainer extends React.Component {
  render() {
    let {
      showContent,
      toggleShowContent,
      content,
      trigger,
      controls,
      className,
    } = this.props;
    let collapsibleClassNames = classnames('ot-collapsible-form', className, {
      'ot-collapsible-form--icon-open': showContent,
    });

    return (
      <Collapsible
        className={collapsibleClassNames}
        openedClassName={collapsibleClassNames}
        handleTriggerClick={toggleShowContent}
        open={true}
        trigger={trigger}
      >
        {showContent && content}
        {controls}
      </Collapsible>
    );
  }
}

CollapsibleContainer.propTypes = {
  showContent: PropTypes.bool,
  toggleShowContent: PropTypes.func,
  content: PropTypes.element,
  trigger: PropTypes.element,
  controls: PropTypes.element,
  className: PropTypes.string,
};

export default CollapsibleContainer;
